<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <button
    :class="[
      button({ intent, size }),
      'flex items-center justify-center whitespace-nowrap px-4',
      full && 'w-full',
      {
        [disabledClass[intent as keyof typeof disabledClass]]: disabled,
        'pointer-events-none': loading
      },
      mobile && 'rounded-full !py-3 px-6'
    ]"
  >
    <slot />
    <div
      v-if="!loading && icon"
      :class="
        twJoin(
          'ml-2 fill-primary-white',
          hideIconOnMobile && ' hidden md:block'
        )
      "
    >
      <Icon :name="icon" />
    </div>
    <div v-if="loading" class="fill-primary-white animate-spin ml-2">
      <Icon name="circle-notch" />
    </div>
  </button>
</template>

<script lang="ts" setup>
import { cva, type VariantProps } from 'class-variance-authority'
import { twJoin } from 'tailwind-merge'
import type { CaseclubIconsId } from '~/public/fonts/CaseClubFontIcons/caseclub-icons'

const button = cva('py-4 rounded-2xl text-base font-bold', {
  variants: {
    intent: {
      primary: 'bg-primary-tangerine text-white active:bg-[#B22E00]',
      'primary-outline':
        'bg-white border-primary-tangerine border-[2px] text-primary-tangerine active:bg-primary-tangerine',
      secondary: 'bg-black text-white',
      disabled_secondary: 'bg-black text-white  pointer-events-none ',
      text: '!py-0 h-fit !px-0 !w-fit font-medium flex-row-reverse gap-1'
    },
    size: {
      normal: 'px-4 md:px-8 ',
      large: 'px-[62px]'
    }
  }
})

const disabledClass = {
  primary:
    '!bg-gray-10 !text-typo-disabled pointer-events-none fill-typo-disabled',
  secondary: '!bg-gray-10 !text-typo-disabled pointer-events-none'
}

type ButtonProps = VariantProps<typeof button>

withDefaults(
  defineProps<{
    intent?: ButtonProps['intent']
    size?: ButtonProps['size']
    disabled?: boolean
    loading?: boolean
    full?: boolean
    icon?: CaseclubIconsId | undefined
    hideIconOnMobile?: boolean
    mobile?: boolean
  }>(),
  {
    intent: 'primary',
    size: 'normal',
    icon: undefined
  }
)
</script>
